import { CheckCircleOutlined, CheckOutlined, ClockCircleOutlined, CloseOutlined, LoadingOutlined, StarFilled, TagOutlined } from "@ant-design/icons";
import { Card, Rate, Form, Tag, Input, Spin, message, Tooltip, Divider, Modal, Button } from "antd";
import { useEffect, useState } from "react";
import moment from "moment";
import { authRequest } from "../../../common/request/authRequest";
import { ReviewAnswer } from "./ReviewAnswer";
import ReviewComment from "./ReviewComment";

export default function ReviewSelected({ keyId, reviewId, onFinish}) {  
  
  const [status, setStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [review, setReview] = useState(null);
  const [refreshReview, setRefreshReview] = useState(true);
  const [replyForm] = Form.useForm();

  const [selectedLanguage, setSelectedLanguage] = useState('');

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  const submitReply = async ({ comment }) => {

    const data = {
      comment,
      reviewId: review.name 
    };

    try {
    
      await authRequest(
        `${process.env.REACT_APP_API}/widgets/reply-reviews/reply?key=${keyId}`,
        { method: 'PUT', data: data });      

        setRefreshReview(!refreshReview);
        setStatus('');
        onFinish();
        message.success('Reseña contestada con éxito', 3);
       
    } catch (error) {
      message.error('Error al contestar la reseña', 3);          
    }
  };

  useEffect(() => {

    setStatus('')
    replyForm.resetFields();
    //console.log("/review" + reviewId)
    if (reviewId !== null) {

      setReview(null);
      authRequest(`${process.env.REACT_APP_API}/widgets/reply-reviews/${reviewId}?key=${keyId}`, {}).then((data) => {
        
        if (data.deleted) {
          reviewId = null;
          message.info("Esta reseña ya no existe en Google");
          onFinish();
        } else {
          setReview(data);
        }
      })
    } 
  }, [reviewId, refreshReview])

  const daysAgo = (date) => {
    const oneDay = 24 * 60 * 60 * 1000
    return Math.round(Math.abs((Date.now() - new Date(date).getTime()) / oneDay));
  };

  const getResponseIa = async () => {
    
    setIsLoading(true)    
    await authRequest(`${process.env.REACT_APP_API}/widgets/reply-reviews/chat/${reviewId}?key=${keyId}&reviewerName=${encodeURIComponent(review?.reviewerDisplayName)}&starRating=${review?.starRating}&content=${encodeURIComponent(review?.comment.originalText ? review?.comment.originalText : review?.comment.text)}&language=${selectedLanguage}`, {})
    .then((data) => {
      handleOpenTextArea(data)
      setIsLoading(false)
    }).catch((error) => {
      setIsLoading(false)
    });
  }

  const handleOpenTextArea = (responseText) => {
    replyForm.setFieldsValue({ comment: responseText });
  };

/*
  const [showPicker, setShowPicker] = useState(false);

  const [cursorIndex, setCursorIndex] = useState(0);

  const handleFocus = (event) => {
      setShowPicker(false);        
  }

  const handleBlur = (event) => {
      setCursorIndex(event.target.selectionStart);
  };*/

  return (
    <div 
      style={{ marginTop:'15px', background: review ? (!review?.reviewReplyComment ? 'ivory' : '#F3FFFA') : 'white' }}
    >
      {review ? (
        <Card
          className='card-layout'          
          size='small'
          extra={            
            <h3>{!review.reviewReplyComment ? <div style={{color:'MediumVioletRed'}}><ClockCircleOutlined/> Pendiente</div> : <div  style={{color:'darkgreen'}}><CheckCircleOutlined/> Respondida</div>}</h3>                          
          }
          title={
            <Rate
              disabled={true}
              color= 'black'
              allowHalf
              value={review.starRating}
            />
        }        
          headStyle={{ borderRadius: '10px', padding:'20px',  background: !review.reviewReplyComment ? 'ivory' : '#F3FFFA' }}
          bodyStyle={{ borderRadius: '10px', background: !review.reviewReplyComment ? 'ivory' : '#F3FFFA' }}
        >
          <div style={{display:'flex', gap:'10px', alignItems: 'center'}}>
            <img src={review.reviewerProfilePhotoUrl} style={{ height: '30px', width: 'auto' }} />
            <div style={{ color: 'black', fontSize: '14px' }}>{review.reviewerDisplayName}</div>
            <small style={{ color: 'gray', display:'flex', justifyContent:'space-between' }}>
                {
                  daysAgo(review.updateTime) > 1 ?
                      <div>
                          <Tooltip title={<>
                                              <div>Creada el {moment(review.createdTime).format('ll')}</div>
                                              {!moment(review.createdTime).isSame(moment(review.updateTime)) && <div>Actualizada el {moment(review.updateTime).format('ll')}</div>}
                                          </>}>
                              {moment(review.updateTime).fromNow()}
                          </Tooltip>
                      </div>
                      :
                    <Tag color={'green'} style={{ borderRadius: '10px' }}>{'NUEVA'}</Tag>
                }
              </small>
          </div>
          <Card 
          style={{border:'transparent solid 0px'}}
            bodyStyle={{ borderRadius: '10px', border:'transparent solid 0px', background: !review.reviewReplyComment ? 'ivory' : '#F3FFFA', padding:'5px' }}>            
            {!!review.comment && <ReviewComment comment={review.comment} scope={''} reviewReplyUpdateTime={review.updateTime} isReply={false}/>}
            
            {review.reviewReplyComment && <ReviewAnswer keyId={keyId} submitReply={submitReply} replyForm={replyForm} getResponseIa={getResponseIa} isLoadingIa={isLoading} review={review} onFinish={() => {setRefreshReview(!refreshReview); onFinish()}} />}
                        
            {!review.reviewReplyComment && status !== STATUS.REPLYING &&
              <Button size='small' style={{ float:'right', clear:'right', margin:'0px 10px', width:'180px'}} shape='round' type='primary' onClick={() => setStatus('Replying')}>              
                  Responder
              </Button>
            }

            {!review.reviewReplyComment && status === STATUS.REPLYING &&
              <div style={{ padding: '5px 25px 25px 25px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <small style={{ color: 'slategrey' }}>Respuesta del propietario</small>
                  <div style={{display:'flex'}}>                      
                    <Button                  
                        style={{ minWidth: '40px', height: '25px', color: 'purple', background: 'var(--dark-white)', border:'1px solid silver', borderTopLeftRadius: '14px', borderBottomLeftRadius: '14px',borderTopRightRadius: '0px', borderBottomRightRadius: '0px', borderRight: 'none' }}
                        onClick={() => {
                          if (!isLoading) {
                            getResponseIa();
                          }
                        }}
                        size='small' >
                          {isLoading ? 
                            <Spin indicator={<LoadingOutlined spin />} /> 
                            : 
                            <span style={{color:'purple'}}>Sugerencia con IA</span>
                          }
                    </Button>
                        <select 
                          value={selectedLanguage}
                          onChange={handleLanguageChange}
                          title="Seleccionar Idioma Opcional" // Título para accesibilidad/tooltip
                          style={{                           
                            backgroundColor: 'var(--dark-white)', // Un color más oscuro para discreción          
                            width: '40px', 
                            height: '25px',          
                            border:'1px solid silver',
                            borderTopRightRadius: '14px', 
                            borderBottomRightRadius: '14px',
                          }}>
                            <option value="">🌎</option> 
                            <option value="inglés">🇬🇧 Inglés</option>
                            <option value="italiano">🇮🇹 Italiano</option>
                            <option value="francés">🇫🇷 Francés</option>
                            <option value="portugués">🇵🇹 Portugués</option>
                            <option value="alemán">🇩🇪 Alemán</option>
                            <option value="sueco">🇸🇪 Sueco</option>
                            <option value="español">🇪🇸 Español</option>        
                            <option value="catalán">ca Catalán</option>
                            <option value="gallego">ga Gallego</option>
                            <option value="valenciano">va Valenciano</option>
                            <option value="esuskera">eu Euskera</option>
                        </select>
                      </div>
                  {/*<ButtonLZ                  
                    onClick={() => {
                      if (!isLoading) {
                        getResponseIa();
                      }
                    }}
                    style={{ minWidth: '40px' }}
                  size='small' color='dark-white'>{isLoading ? <Spin indicator={<LoadingOutlined spin />} /> : t('reviews.page.reply.review.btn.ia')}</ButtonLZ>*/}
                </div>

                <Form layout='vertical'
                  form={replyForm}
                  onFinish={submitReply}>

                  <Form.Item name='comment'>
                    <Input.TextArea
                      style={{ width: '100%', borderRadius: '15px' }}
                      className='input-field'
                      rows={6}
                      //onFocus={handleFocus}
                      //onBlur={handleBlur}
                    />
                  </Form.Item>
                  <a className='review-btn'
                    onClick={() => { replyForm.resetFields(); setStatus(''); }}
                  >
                    <CloseOutlined /> Cancelar
                  </a>
                  <a className='review-btn'
                    onClick={() => { replyForm.submit(); }}
                  >
                    <CheckOutlined /> Aceptar
                  </a>
                  {/*<EmojiPickerCustom  handleEmojiClick={handleEmojiClick} showPicker={showPicker} setShowPicker={setShowPicker}/>*/}
                </Form>
              </div>
            }
          </Card>
          <br/>             
        </Card>
      ) :
        <div className="no-row-select">
          <Spin/>
        </div>
      }
      <div style={{color:'transparent'}}>
        <div>Sincronizada: {review?.syncDateTime && moment(review.syncDateTime).format('ll')}</div>        
        <div>Actualizada: {review?.syncUpdateTime && moment(review.syncUpdateTime).format('ll')}</div>
      </div>    
    </div>
  );
}

export const STATUS = {
  EDITING: 'Editing',
  REPLYING: 'Replying',   
}